import { ICard } from "@/store/apis/deckAPI"
import { EFFECT_TYPES } from "@/store/apis/effectsAPI"

export const mockCardData: ICard = {
  _id: "64b200000000000000000004",
  currency: "speed" as any,
  description: "Dig 5m, -1 rune mining to opponent.",
  effects: [
    {
      _id: "64b100000000000000000001",
      description: "Dig 5m",
      durationMovements: 1,
      playerTarget: "self",
      probabilityPercentage: 100,
      runeTarget: "none",
      type: EFFECT_TYPES.AUTO_DIG,
      value: 5,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    },
    {
      _id: "64b100000000000000000002",
      description: "Rune mining delta -1",
      durationMovements: 1,
      playerTarget: "opponent",
      probabilityPercentage: 100,
      runeTarget: "all",
      type: EFFECT_TYPES.AUTO_DIG,
      value: -1,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    }
  ],
  imgSrc:
    "https://labrador-prj.s3.us-east-2.amazonaws.com/images/fire_trace.webp",
  price: 6,
  type: "fire_trace" as any,
  subType: "regular" as any,
  tier: "regular" as any,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString()
}

export const mockCardGoldData: ICard = {
  _id: "64b200000000000000000025",
  createdAt: "2026-03-04T12:39:42.750Z",
  currency: "stamina",
  description: "+1 unit of all runes within 2 turns",
  effects: [],
  imgSrc: "",
  price: 6,
  subType: "regular" as any,
  tier: "gold" as any,
  type: "rune_master" as any,
  updatedAt: "2026-03-04T12:39:42.750Z"
}
